import React from 'react'
import { IconsProvider } from 'app/react/components/icons/IconsContext'

export default function IconsContainer ({
  children,
  headerTitle = '',
  headerText = '',
  image = {},
  imageTitle = '',
  imageText = '',
  files = [],
  buttonTexts = {}
}) {

  const contextObjext = {
    headerTitle: headerTitle,
    headerText: headerText,
    image: image,
    imageTitle: imageTitle,
    imageText: imageText,
    files: files,
    buttonTexts: buttonTexts
  }

  return (
    <IconsProvider value={contextObjext}>
      {children}
    </IconsProvider>
  )
}